import { render } from "./Received_Order_Details.vue?vue&type=template&id=c3bf41a0"
import script from "./Received_Order_Details.vue?vue&type=script&lang=js"
export * from "./Received_Order_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__